import React from "react";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import IconButton from "@material-ui/core/IconButton";
import Avatar from "@material-ui/core/Avatar";
import { Formatters } from "../../../Utils/Formatters";
import DeleteIcon from "@material-ui/icons/Delete";
import { withNamespaces } from "react-i18next";

const getSecondaryText = (booking) => {
  if (booking.date) {
    return `El ${Formatters.formatDate(
      booking.date
    )} de ${Formatters.formatTime(booking.start_at)} a ${Formatters.formatTime(
      booking.end_at
    )}`;
  }

  return `Los ${Formatters.dayweekNumberToLabel(
    booking.day_of_week
  )} de ${Formatters.formatTime(booking.start_at)} a ${Formatters.formatTime(
    booking.end_at
  )}`;
};

const BookingList = ({ t, bookings, handleRemoveBooking }) => {
  if (!bookings) {
    return <p>{t("Loading")}...</p>;
  }

  if (bookings.length === 0) {
    return <p>{t("No bookings... Add a new one to start.")}</p>;
  }

  return (
    <List>
      {bookings.map((item) => {
        try {
          return (
            <ListItem key={item.id}>
              <ListItemIcon>
                <Avatar>{item.name.charAt(0).toUpperCase()}</Avatar>
              </ListItemIcon>
              <ListItemText
                primary={item.name}
                secondary={getSecondaryText(item)}
              />
              <ListItemSecondaryAction>
                <IconButton
                  aria-label="Delete"
                  onClick={(event) => handleRemoveBooking(item.id, event)}
                >
                  <DeleteIcon />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
          );
        } catch {
          return <ListItem key={item.id}>Error en item {item.id}</ListItem>;
        }
      })}
    </List>
  );
};

export default withNamespaces()(BookingList);
